import { MuiTheme, createStyles, makeStyles, radius } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    gridContainer: {
      alignItems: 'center',
      display: 'flex',
      height: '100vh',
      justifyContent: 'center',
      minHeight: '640px'
    },
    gridItem: {
      background: 'white',
      borderRadius: radius.SUBTLE,
      display: 'flex',
      flexDirection: 'column',
      height: '640px',
      maxWidth: '587px',
      padding: '32px',
      [theme.breakpoints.down('sm')]: {
        height: '100vh',
        width: '100%'
      }
    },
    logoBox: {
      justifyContent: 'center',
      margin: '0 0 32px'
    },
    headerBox: {
      margin: '0 0 32px'
    },
    header: {
      lineHeight: '1.2',
      fontWeight: 600,
      fontSize: '32px'
    },
    contentBox: {
      flex: '1'
    },
    footerBox: {
      alignItems: 'center',
      height: '45px'
    },
    infoText: {
      fontSize: '14px',
      lineHeight: '1.5',
      fontWeight: 600,
      color: '#999999'
    }
  })
);
